import React, { useEffect, useState } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Img_1 from '../../images/events-1.jpeg'
import Location from '../../modal/Location';
import * as colors from "../../assets/css/Colors";
import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';

const Event = () => {
     // Start color change auto function
   const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  // End color change auto function
  const [pincode, setPincode] = useState('');
  const [error, setError] = useState(null);

  const handleLocationUpdate = async (updatedLocation) => {
    try {
      const pincodeMatch = updatedLocation.match(/\b\d{6}\b/);
      const newPincode = pincodeMatch ? pincodeMatch[0] : '';
      setPincode(newPincode);
    } catch (error) {
      setError(error.message);
    }
  };
  const boxstyleqrcode = {
    border: `2px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
    borderRadius: '8px',
  };

    var Events = {
        dots: false,
        arrow: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };
      
  return (
    <section className="news-hom-ban-sli pb-40">
        <div className='loctionbuttonhide'>
  <Location onLocationUpdate={handleLocationUpdate}/>
  </div>
  
        <div className="news-hom-ban-sli-inn">
        <div className="home-tit">
          <h2><span> Detailed Information on Local Area</span> <form onSubmit={(e) => e.preventDefault()}>
            <input
              type="text" className='popuple-data-count-pincode' style={boxstyleqrcode}
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              placeholder="Pincode"
            />
          </form><span>&nbsp;Events </span></h2>
          <p>Which local area's information would you like to know? Enter the pincode of that local area where a pincode (6 digits) is already available.</p>
          <p>Explore detailed information about local events, including schedules, venues, and participation details. Stay updated on what's happening in your area and get insights into upcoming activities.</p>
        </div>
           
            <Slider {...Events}>
                    <div className="news-hban-box">
                        <div className="im">
                            <img loading="lazy" src={Img_1} alt=""/>
                        </div>
                        <div className="txt">
                            <span className="news-cate">Top events</span><br></br>
                            <span className="eve-date-sli">11 <b>Mar</b></span>
                            <h2>Chicago bike trails for a long ride</h2>
                        </div>
                        <a href="" className="fclick"></a>
                    </div>
                    <div className="news-hban-box">
                        <div className="im">
                            <img loading="lazy" src={Img_1} alt=""/>
                        </div>
                        <div className="txt">
                            <span className="news-cate">Top events</span><br></br>
                            <span className="eve-date-sli">11 <b>Mar</b></span>
                            <h2>Chicago bike trails for a long ride</h2>
                        </div>
                        <a href="" className="fclick"></a>
                    </div>
                    <div className="news-hban-box">
                        <div className="im">
                            <img loading="lazy" src={Img_1} alt=""/>
                        </div>
                        <div className="txt">
                            <span className="news-cate">Top events</span><br></br>
                            <span className="eve-date-sli">11 <b>Mar</b></span>
                            <h2>Chicago bike trails for a long ride</h2>
                        </div>
                        <a href="" className="fclick"></a>
                    </div>
                    <div className="news-hban-box">
                        <div className="im">
                            <img loading="lazy" src={Img_1} alt=""/>
                        </div>
                        <div className="txt">
                            <span className="news-cate">Top events</span><br></br>
                            <span className="eve-date-sli">11 <b>Mar</b></span>
                            <h2>Chicago bike trails for a long ride</h2>
                        </div>
                        <a href="" className="fclick"></a>
                    </div>
                    <div className="news-hban-box">
                        <div className="im">
                            <img loading="lazy" src={Img_1} alt=""/>
                        </div>
                        <div className="txt">
                            <span className="news-cate">Top events</span><br></br>
                            <span className="eve-date-sli">11 <b>Mar</b></span>
                            <h2>Chicago bike trails for a long ride</h2>
                        </div>
                        <a href="" className="fclick"></a>
                    </div>
                    <div className="news-hban-box">
                        <div className="im">
                            <img loading="lazy" src={Img_1} alt=""/>
                        </div>
                        <div className="txt">
                            <span className="news-cate">Top events</span><br></br>
                            <span className="eve-date-sli">11 <b>Mar</b></span>
                            <h2>Chicago bike trails for a long ride</h2>
                        </div>
                        <a href="" className="fclick"></a>
                    </div>
                </Slider>
                <div className='view-more-button'>
        <Link to="/Card">
          <span className="btn-ser-need-ani Add-Any-Equation" style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>More Information of Your Local Area</span>
        </Link>
      </div>
        </div>

     
    </section>
  )
}

export default Event